import { FC } from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { PurposeAIGenerateFormData } from './purpose-ai-generate.schema';

interface PurposeAIGenerateFormProps {
  control: Control<PurposeAIGenerateFormData>;
  errors: FieldErrors<PurposeAIGenerateFormData>;
  isLoading?: boolean;
}

const PurposeAIGenerateForm: FC<PurposeAIGenerateFormProps> = ({ control, errors, isLoading = false }) => {
  return (
    <div className="space-y-5">
      {/* Company Name */}
      <div>
        <label htmlFor="company_name" className="block text-sm font-medium text-gray-700 mb-2">
          Company Name <span className="text-gray-400">(Optional)</span>
        </label>
        <Controller
          name="company_name"
          control={control}
          render={({ field }) => (
            <textarea
              {...field}
              id="company_name"
              rows={2}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.company_name ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="Berisikan identitas perusahaan"
              disabled={isLoading}
            />
          )}
        />
        {errors.company_name && <p className="text-sm text-red-500 mt-1">{errors.company_name.message}</p>}
        <p className="text-xs text-gray-500 mt-1">Berisikan identitas perusahaan</p>
      </div>

      {/* Industry */}
      <div>
        <label htmlFor="industry" className="block text-sm font-medium text-gray-700 mb-2">
          Industry <span className="text-gray-400">(Optional)</span>
        </label>
        <Controller
          name="industry"
          control={control}
          render={({ field }) => (
            <textarea
              {...field}
              id="industry"
              rows={2}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.industry ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="e.g., Technology, Retail, Healthcare"
              disabled={isLoading}
            />
          )}
        />
        {errors.industry && <p className="text-sm text-red-500 mt-1">{errors.industry.message}</p>}
        <p className="text-xs text-gray-500 mt-1">
          Menjelaskan bidang usaha perusahaan. Contoh: Technology, Retail, etc
        </p>
      </div>

      {/* Target Market */}
      <div>
        <label htmlFor="target_market" className="block text-sm font-medium text-gray-700 mb-2">
          Target Market <span className="text-gray-400">(Optional)</span>
        </label>
        <Controller
          name="target_market"
          control={control}
          render={({ field }) => (
            <textarea
              {...field}
              id="target_market"
              rows={3}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.target_market ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="e.g., UMKM di Indonesia yang bergerak di bidang F&B"
              disabled={isLoading}
            />
          )}
        />
        {errors.target_market && <p className="text-sm text-red-500 mt-1">{errors.target_market.message}</p>}
        <p className="text-xs text-gray-500 mt-1">
          Menjelaskan kelompok spesifikasi pelanggan yang menjadi fokus utama penjualan atau pemasaran produk/layanan
        </p>
      </div>

      {/* Current Activities */}
      <div>
        <label htmlFor="current_activities" className="block text-sm font-medium text-gray-700 mb-2">
          Current Activities <span className="text-gray-400">(Optional)</span>
        </label>
        <Controller
          name="current_activities"
          control={control}
          render={({ field }) => (
            <textarea
              {...field}
              id="current_activities"
              rows={3}
              className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                errors.current_activities ? 'border-red-500' : 'border-gray-300'
              }`}
              placeholder="e.g., Sedang dalam tahap beta testing"
              disabled={isLoading}
            />
          )}
        />
        {errors.current_activities && <p className="text-sm text-red-500 mt-1">{errors.current_activities.message}</p>}
        <p className="text-xs text-gray-500 mt-1">
          Menjelaskan pekerjaan utama yang sedang dilakukan perusahaan saat ini
        </p>
      </div>
    </div>
  );
};

export default PurposeAIGenerateForm;
